import { NotificationAck, NotificationRecord } from '../types/Notifications/types';
import { StorageService } from './storage';

const NOTIFICATIONS_STORAGE_PREFIX = 'NOTIFICATIONS_STATE';

export interface PersistedNotificationsState {
  items: NotificationRecord[];
  pendingAcks: NotificationAck[];
  lastSyncAt: string | null;
  lastCursor: string | null;
}

const buildNotificationsStorageKey = (scope: string): string =>
  `${NOTIFICATIONS_STORAGE_PREFIX}::${encodeURIComponent(scope || 'anonymous')}`;

export const loadNotificationsState = async (
  scope: string,
): Promise<PersistedNotificationsState | null> => {
  const raw = await StorageService.get(buildNotificationsStorageKey(scope));

  if (!raw) return null;

  try {
    return JSON.parse(raw) as PersistedNotificationsState;
  } catch (error) {
    console.error('[Notifications] Error parsing persisted state', error);
    return null;
  }
};

export const saveNotificationsState = async (
  scope: string,
  state: PersistedNotificationsState,
): Promise<void> => {
  await StorageService.set(buildNotificationsStorageKey(scope), JSON.stringify(state));
};

export const clearNotificationsState = async (scope: string): Promise<void> => {
  await StorageService.remove(buildNotificationsStorageKey(scope));
};
